import { genericPage, getMappingProgramaSlug, getServerSidePropsHelper, isCr } from 'components/3cat/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
// /nom-bonic-programa/fitxa/nom-fitxa/id/
// Programa TV:  https://www.3cat.cat/3cat/euforia/fitxa/360-immersiu/142120/
// Programa Radio:  https://www.3cat.cat/3cat/el-mati-de-catalunya-radio/fitxa/mon-enigmarius/5348/
const pathTv = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'fitxa'];
const pathRadio = ['web', process.env.FOLDER_LAYOUTS, 'programa', 'fitxa-radio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, pathTv);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    const mapping = await getMappingProgramaSlug(slug);

    if (__isEmpty(mapping) || !mapping.id) {
        return {
            notFound: true
        };
    }

    const path = isCr(mapping) ? pathRadio : pathTv;

    const options = {
        slugs: path,
        id: mapping.id
    };

    return getServerSidePropsHelper(context, options);
}

export default Pagina;
